module.exports = __webpack_public_path__ + "a443772cc72c329389eccaad74844fcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2022_teaser_image.jpg
// module id = 574
// module chunks = 0